(function () {
  var namespace = window.ATOTOActivityDiscountCollection || {};
  var storageKey = 'activityDiscountCollection';
  var selector = '[data-activity-discount-collection-config]';
  var observer = null;
  var writeTimer = null;
  var clearTimer = null;

  function clearStorage() {
    try {
      window.localStorage.removeItem(storageKey);
      return true;
    } catch (error) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn('activityDiscountCollection 清理失败', error);
      }

      return false;
    }
  }

  function parseJson(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (error) {
      return fallback;
    }
  }

  function getPageInfo() {
    var page = namespace.page || {};

    return {
      type: page.type || '',
      handle: page.handle || '',
      template: page.template || '',
      template_name: page.templateName || '',
      template_suffix: page.templateSuffix || '',
      path: page.path || window.location.pathname || ''
    };
  }

  function getStoredPageInfo() {
    var storedValue;
    var parsedValue;

    try {
      storedValue = window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }

    if (!storedValue) return null;

    parsedValue = parseJson(storedValue, null);

    return parsedValue && parsedValue.page ? parsedValue.page : null;
  }

  function pageMatchesCurrent(storedPage) {
    var currentPage = getPageInfo();

    if (!storedPage) return false;

    if (storedPage.path && currentPage.path && storedPage.path === currentPage.path) {
      return true;
    }

    if (storedPage.handle && currentPage.handle && storedPage.handle === currentPage.handle) {
      return true;
    }

    return Boolean(
      storedPage.template_suffix &&
        currentPage.template_suffix &&
        storedPage.template_suffix === currentPage.template_suffix
    );
  }

  function clearStorageForCurrentPage() {
    return pageMatchesCurrent(getStoredPageInfo()) ? clearStorage() : false;
  }

  function getConfigNodes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = [];

    if (scope.matches && scope.matches(selector)) {
      nodes.push(scope);
    }

    nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));

    if (!nodes.length && scope !== document) {
      nodes = Array.prototype.slice.call(document.querySelectorAll(selector));
    }

    return nodes;
  }

  function parseConfigNode(configNode) {
    if (!configNode) return null;

    return parseJson(configNode.textContent || '[]', null);
  }

  function getMarketLabel(value, countryLabels) {
    var labels =
      countryLabels || {
        RU: '俄罗斯',
        CA: '加拿大',
        DE: '德国',
        IT: '意大利',
        JP: '日本',
        EU_OTHER: '欧盟其他',
        FR: '法国',
        AU: '澳大利亚',
        LATAM_US: '秘鲁/墨西哥/阿根廷/哥伦比亚-美',
        US: '美国',
        GB: '英国',
        ES: '西班牙'
      };

    return labels[value] || value;
  }

  function normalizeSelectedMarkets(values, markets, countryLabels) {
    if (Array.isArray(markets)) return markets;

    return values.map(function (value) {
      return {
        value: value,
        label: getMarketLabel(value, countryLabels)
      };
    });
  }

  function normalizeOfferConfig(offerConfig, countryLabels) {
    var selectedMarketValues =
      offerConfig.selected_market_values || offerConfig.selected_country_values || [];
    var relatedCollections =
      offerConfig.related_collections || offerConfig.collections || [];

    if (!relatedCollections.length && offerConfig.collection) {
      relatedCollections = [offerConfig.collection];
    }

    return {
      related_collections: relatedCollections,
      enable_market_selection: Boolean(offerConfig.enable_market_selection),
      selected_markets: normalizeSelectedMarkets(
        selectedMarketValues,
        offerConfig.selected_markets,
        countryLabels
      ),
      discount_text: offerConfig.discount_text || '',
      tip_text: offerConfig.tip_text || ''
    };
  }

  function normalizeConfig(config) {
    if (Array.isArray(config)) {
      return config.map(function (offerConfig) {
        return normalizeOfferConfig(offerConfig);
      });
    }

    if (config && Array.isArray(config.discount_items)) {
      return config.discount_items.map(function (offerConfig) {
        return normalizeOfferConfig(offerConfig, config.country_label);
      });
    }

    return [];
  }

  function mergeConfigs(configs) {
    return configs.reduce(function (items, config) {
      return items.concat(normalizeConfig(config));
    }, []);
  }

  function getConfigPageInfo(configNodes) {
    var configNode = configNodes && configNodes[0];
    var dataset = configNode && configNode.dataset ? configNode.dataset : null;

    if (!dataset) return getPageInfo();

    return {
      type: dataset.activityDiscountPageType || '',
      handle: dataset.activityDiscountPageHandle || '',
      template: '',
      template_name: dataset.activityDiscountTemplateName || '',
      template_suffix: dataset.activityDiscountTemplateSuffix || '',
      path: dataset.activityDiscountPagePath || ''
    };
  }

  function buildStorageValue(discountItems, pageInfo) {
    return {
      page: pageInfo || getPageInfo(),
      discount_items: discountItems
    };
  }

  function write(root) {
    var configNodes = getConfigNodes(root);

    if (!configNodes.length) {
      return false;
    }

    try {
      var configs = configNodes.map(parseConfigNode).filter(Boolean);
      var mergedConfig;

      if (!configs.length) {
        return false;
      }

      mergedConfig = mergeConfigs(configs);

      window.localStorage.setItem(
        storageKey,
        JSON.stringify(buildStorageValue(mergedConfig, getConfigPageInfo(configNodes)))
      );
      return true;
    } catch (error) {
      if (window.Shopify && window.Shopify.designMode) {
        console.warn('activityDiscountCollection 写入失败', error);
      }

      return false;
    }
  }

  function scheduleWrite(root) {
    window.clearTimeout(writeTimer);

    writeTimer = window.setTimeout(function () {
      write(root || document);
    }, 0);
  }

  function scheduleCurrentPageClear() {
    var pathAtSchedule = window.location.pathname || '';

    window.clearTimeout(clearTimer);

    clearTimer = window.setTimeout(function () {
      if ((window.location.pathname || '') !== pathAtSchedule) return;
      if (getConfigNodes(document).length) return;

      clearStorageForCurrentPage();
    }, 250);
  }

  function nodeContainsConfig(node) {
    if (!node || node.nodeType !== 1) return false;

    return (
      (node.matches && node.matches(selector)) ||
      (node.querySelector && node.querySelector(selector))
    );
  }

  function mutationTargetContainsConfig(mutation) {
    var target = mutation.target;
    var element;

    if (!target) return false;

    element = target.nodeType === 1 ? target : target.parentElement;

    return Boolean(
      element &&
        ((element.matches && element.matches(selector)) ||
          (element.closest && element.closest(selector)) ||
          nodeContainsConfig(element))
    );
  }

  function observeConfigNodeChanges() {
    if (observer || !window.MutationObserver || !document.documentElement) return;

    observer = new MutationObserver(function (mutations) {
      var shouldWrite = mutations.some(function (mutation) {
        if (mutation.type === 'characterData' || mutation.type === 'attributes') {
          return mutationTargetContainsConfig(mutation);
        }

        return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
          return nodeContainsConfig(node);
        });
      });
      var removedConfigNode = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.removedNodes || [], function (node) {
          return nodeContainsConfig(node);
        });
      });

      if (shouldWrite) {
        scheduleWrite(document);
      } else if (removedConfigNode) {
        scheduleCurrentPageClear();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      characterData: true,
      attributes: true,
      subtree: true
    });
  }

  namespace.write = write;
  namespace.clear = clearStorage;
  namespace.storageKey = storageKey;
  window.ATOTOActivityDiscountCollection = namespace;

  if (namespace.initialized) {
    write(document);
    return;
  }

  namespace.initialized = true;
  observeConfigNodeChanges();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      write(document);
    });
  } else {
    write(document);
  }

  window.addEventListener('load', function () {
    write(document);
  });

  window.addEventListener('pageshow', function () {
    write(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    write(document);
  });

  document.addEventListener('shopify:section:unload', function () {
    scheduleCurrentPageClear();
  });

  document.addEventListener('shopify:section:select', function (event) {
    write(document);
  });

  document.addEventListener('shopify:section:reorder', function () {
    write(document);
  });
})();
